import getRoundedNum from "./getRoundedNum";
import { Paragraph } from "../types/transcriptApiTypes";

// This is performance sensitive code given potentially large numbers of
// paragraphs. Prefer loops and mutation over array methods like map/reduce.
//
// BE VERY CAREFUL not to introduce XSS vunerabilities, as we are skipping
// outside Preact/framework that helps you avoid these by default. Chat with
// a front-end expert if you are unsure about any string interpolation from
// our transcript data. The current format cannot necessarily be trusted
// to be sanitized in advance.
export function paragraphsToTranscriptHTML(
  paragraphs: Paragraph[],
  paragraphClass: string
): string {
  let exportHTML = "";

  // Since we don't have a Sanitization API stable in browsers yet,
  // we'll use an element to take advantage of built-in sanitization with
  // innerText/innerHTML.
  //
  // We reuse a single element for each word to keep things cheap.
  let sanitizationElement = document.createElement("div");

  for (let index = 0; index < paragraphs.length; index += 1) {
    const paragraph = paragraphs[index];
    const nextParagraph = paragraphs[index + 1];

    // Open tag (TODO add attributes)
    exportHTML += `<p class="${paragraphClass}" data-index="${index}" data-mil-start="${
      paragraph.millisecond
    }" data-mil-end="${nextParagraph?.millisecond || ""}">`;

    for (
      let wordIndex = 0;
      wordIndex < paragraph.words.length;
      wordIndex += 1
    ) {
      const word = paragraph.words[wordIndex];
      const nextWord = paragraph.words[wordIndex + 1];

      sanitizationElement.innerText = word.text;
      const sanitizedText = sanitizationElement.innerHTML;

      const nextMillisecond = nextWord
        ? getRoundedNum(nextWord.millisecond)
        : undefined;

      const spaceInSpan = getRoundedNum(word.millisecond) === nextMillisecond;

      const sanitizedContent = word.italic
        ? `<i>${sanitizedText}</i>`
        : sanitizedText;

      exportHTML += `<span data-index="${wordIndex}" data-mil="${
        word.millisecond
      }" data-rounded-mil="${getRoundedNum(
        word.millisecond
      )}">${sanitizedContent}${spaceInSpan ? " " : ""}</span>`;

      if (!spaceInSpan && wordIndex !== paragraph.words.length - 1) {
        exportHTML += " ";
      }
    }

    exportHTML += "</p>";
  }

  return exportHTML;
}
